module.exports = __webpack_public_path__ + "static/media/notification.21490b16.svg";